import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink, from } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { handleSessionError } from './ErrorHandler'

const dataApiUrl = import.meta.env.VITE_DATA_API_ENDPOINT

const httpLink = createHttpLink({
  uri: `${dataApiUrl}/graphql`
})

const authLink = new ApolloLink((operation, forward) => {
  if (operation.getContext().requestRole) {
    // @ts-expect-error Apollo context typings don't expose headers shape here
    operation.setContext(({ headers }) => ({
      headers: {
        'X-MS-API-ROLE': operation.getContext().requestRole,
        ...headers
      }
    }))
  }
  return forward(operation)
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      if (err.extensions?.code === 'AUTH_NOT_AUTHENTICATED') {
        console.error('Authentication error:', err)
        handleSessionError(
          'An error occurred. Please refresh the page. If error persists, try loging out and back in again.',
          true,
          0,
          'Refresh',
          true
        )
      }
    })
  }

  if (networkError) {
    console.error('Network error:', networkError)
    // Handle CORS or fetch-related errors
    if (networkError.message.includes('Failed to fetch') || networkError.message.includes('CORS')) {
      handleSessionError(
        'An error occurred. Please refresh the page. If error persists, try loging out and back in again.',
        true,
        0,
        'Refresh',
        true
      )
    }
  }
})

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache()
})

export default client
